import React from 'react'

export const LoginSpotify = () => {
  return (
    <div className="content">
      <div className="content-child">
        <div className="login-form">
          <img className="logo-form" src="https://cdn.worldvectorlogo.com/logos/spotify-2.svg" alt="Logo spotify" />
          <h1>Welcome to Spotify Simulator!</h1>
          <a className="login-link" href="https://aba-server.herokuapp.com/login">
            <button className="login-btn">Login with your account to proceed</button>
          </a>
        </div>
      </div>
    </div>
  )
}
